import type { ReactNode } from 'react';
import { styled } from 'styled-components';
import { Button } from '../Button';
import { Icon } from '../Icon';
import type { ButtonAsLinkProps } from '../Button/Button';

export type BreadcrumbProps = ButtonAsLinkProps & {
  /**
   * An [Icon]() to show at the beginning of the breadcrumb
   */
  icon?: ButtonAsLinkProps['leftIcon'];

  /**
   * The text of the breadcrumb link
   */
  children: ReactNode;

  /**
   * The link to the page of the breadcrumb
   */
  href: string;
};

const BreadcrumbContent = styled.span`
  overflow: hidden;
  white-space: nowrap;
  display: block;
  text-overflow: ellipsis;
  text-align: left;
  flex: 0;
`;

export const Breadcrumb = ({ icon, href, children, ...props }: BreadcrumbProps) => {
  return (
    <>
      <Button
        {...props}
        href={href}
        leftIcon={icon}
        variant="ghost"
      >
        <BreadcrumbContent data-wui-breadcrumb={true}>{children}</BreadcrumbContent>
      </Button>
      <div data-wui-breadcrumb-divider={true}>
        <Icon
          size="sm"
          style={{ flex: '0 1 auto' }}
          type="caret-right"
        />
      </div>
    </>
  );
};
